import Vue from 'vue';
import {Component, Ref} from 'vue-property-decorator';
import FormBuilder from './core/FormBuilder.vue';
import Form, {FieldType} from './core/Form';
import {required, email} from './core/validators';
import generateRandomID from './core/generateRandomID';
import { Alert, successMessage, errorMessage } from "@rawlplug/styled-alerts";
import ResponseStatusManager from "@rawlplug/response-manager";
import axios from "axios";
import getSettings from "@/settings/settings";

@Component({
    components: {VAlert: Alert, FormBuilder}
})
export default class TheContact extends Vue {
    @Ref() readonly formBuilder!: FormBuilder;
    form!: Form ;
    message: any = null;
    responseManager: any = new ResponseStatusManager()

    onSuccess() {// @ts-ignore
        this.message = successMessage(this.$t('contact-form-success'));
        // @ts-ignore
        this.formBuilder.reset();
    }

    onFailure() {// @ts-ignore
        this.message = errorMessage(this.$t('contact-form-error'));
    }

    created() {
        this.responseManager.register(/^2..$/, this.onSuccess);
        this.responseManager.catch(this.onFailure);
        this.responseManager.error(this.onFailure);

        this.form = new Form([
                {
                    name: "fullName",// @ts-ignore
                    label: this.$t('contact-fullName') as string,
                    type: FieldType.text,
                    validations: {
                        required
                    },
                    colSpan: 1,
                },
                {
                    name: "email",// @ts-ignore
                    label: this.$t('contact-email') as string,
                    type: FieldType.text,
                    validations: {},
                    colSpan: 1,
                },
                {
                    name: "message",// @ts-ignore
                    label: this.$t('contact-message') as string,
                    type: FieldType.textarea,
                    validations: {},
                    colSpan: 2,
                }
            ],
            {
                consents: {
                    application: 'sc40system',
                    language: 'pl'
                },
                validationMessages: {
                    required() {
                        // @ts-ignore
                        return this.$t('contact-field-required') as string
                    },
                    checked() {
                        // @ts-ignore
                        return this.$t('contact-field-required') as string
                    },
                    email() {
                        // @ts-ignore
                        return this.$t('contact-field-invalid') as string
                    }
                }
            });
    }

    async submit() {
        // @ts-ignore
        if (!this.formBuilder.validate()) {
            // @ts-ignore
            this.message = errorMessage(this.$t('contact-form-invalid'));
            return;
        }
        const model = {
            // @ts-ignore
            ...this.formBuilder.getData(),
            formCode: 'services_contact',
            owner: getSettings().owner,
        }
        this.message = null;

        try {
            const res = await axios({
                method: 'post',
                url: 'https://form-flow.rawl-app.com/',
                data: model,
                headers: { 'Content-Type': 'application/json' },
            })
            this.responseManager.call(res, res.status);
        } catch (e) {
            this.responseManager.sendError(e);
        }
    }
}
